import React, { useState } from "react";
import {
	bannerBike,
	BannerSlide1,
	Benefit1,
	Benefit2,
	Benefit3,
	Benefit4,
	Easy1,
	Easy2,
	EasyBefore,
	LeftBefore,
	m1,
	m2,
	m3,
	m4,
	m5,
	m6,
	Product1,
	Product2,
	Product3,
	Product4,
	ReviewImg1,
	ReviewImg2,
	ReviewImg3,
	ReviewImg4,
} from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/services.css";
import { useGetServicesQuery } from "../../store/services/InnerServices";
import Spinner from "../../utils/Loader";
import { useSiteSettingsQuery } from "../../store/services/HomeServices";
import { useClientsReviewsQuery } from "../../store/services/ClientsReview";
import { useBenefitsContentQuery } from "../../store/services/FaqsServices";
let ImageUrl = "http://flit-backend.developer-ourbase-camp.com/uploads/";

const Services = () => {
	let navigate = useNavigate();
	const { data, isFetching } = useGetServicesQuery();
	const { data: Response, isFetching: load } = useSiteSettingsQuery();
	const { data: clientResponse, isFetching: clientreviewload } =
		useClientsReviewsQuery();
	const { data: beniftResponse, isFetching: beniload } =
		useBenefitsContentQuery();

	return (
		<>
			{!isFetching ? (
				<div className="services">
					{/* Header */}
					<Header />
					{/* Header */}

					{/* Easy Plan Sec Start Here */}
					<section className="easy-plan abcdef">
						<div className="right-before">
							<figure>
								<img src={EasyBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container mt-5">
							<div className="row mb-4">
								<div className="col-lg-12 text-left home-and-product pt-4 mt-1">
									<p>
										<Link to="/">Home</Link> {">"}{" "}
										<Link to="/">Services</Link>
									</p>
								</div>
							</div>
							<div className="heading-wrapper pb-4">
								<h2>
									Our Premium <span className="icon"></span>
									{/* <br /> */}
									<span className="colored">Services</span>
								</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p>
							</div>
						</div>
					</section>
					{/* Easy Plan Sec End Here */}

					{/* services section starts */}
					<section>
						<div className="container">
							<div className="row">
								{data?.response?.data?.map((item, index) => {
									return (
										<>
											<div
												className="col-lg-4 col-md-6 my-3"
												key={index}
												onClick={() => {
													navigate(`/innerservices/${item?.id}`);
												}}
											>
												<img
													className="w-100"
													src={`${ImageUrl}${item?.banner_image}`}
													alt="services"
												/>
												<h4 className="serviceh4 my-3">{item?.title}</h4>
												<div
													dangerouslySetInnerHTML={{
														__html: item?.description?.slice(0, 786),
													}}
												></div>
												<p className="lear_more">Lear More</p>
											</div>
										</>
									);
								})}
							</div>
						</div>
					</section>
					{/* services section ends */}

					{/* Benefits Sec Start Here */}
					<section className="benefits">
						<div className="container">
							<div className="universal-heading">
								{/* <h2>
									<span className="colored">Benefits</span> that we Provide
								</h2>
								<p>
									Est velit egestas dui id ornare arcu odio ut sem. Congue nisi
									vitae suscipit tellus mauris a. Fringilla phasellus faucibus
									scelerisque eleifend donec pretium vulputate sapien. Mus
									mauris vitae ultricies leo integer malesuada. Amet venenatis
									urna cursus eget nunc scelerisque viverra.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html:
											Response?.response?.data[0]?.benefits_heading_and_para,
									}}
								></div>
							</div>
							<div className="benefits-box">
								<div className="row">
									{beniftResponse?.response?.data?.map((item, index) => {
										return (
											<div className="col-lg-3 col-md-6">
												<div className="benefit-dv">
													<div className="icon-dv">
														<figure>
															<img
																src={`${ImageUrl}${item?.icon}`}
																alt=""
																className="img-fluid"
															/>
														</figure>
													</div>
													<div className="txt">
														<h3>{item?.name}</h3>
														<p>{item?.content}</p>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</section>
					{/* Benefits Sec End Here */}

					{/* Client Reviews Sec Start Here */}
					<section className="client-review">
						<div className="before">
							<figure>
								<img src={LeftBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container">
							<div className="universal-heading">
								{/* <h2>
									Have a look at our{" "}
									<span className="colored">Client Reviews</span>
								</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p> */}
								<div
									dangerouslySetInnerHTML={{
										__html:
											Response?.response?.data[0]
												?.client_reviews_heading_and_para,
									}}
								></div>
							</div>
							<div className="row">
								{clientResponse?.response?.data?.map((items, index) => {
									return (
										<div className="col-xl-3 col-lg-6 col-md-6 px-2 mb-3 mb-xl-0" key={index}>
											<div className="review-box">
												<div className="topbar">
													<figure>
														<img
															src={`${ImageUrl}${items?.image}`}
															alt=""
															className="img-fluid"
														/>
													</figure>
													<div className="name">
														<h4 className="name">{items?.name}</h4>
														<p>{items?.designation} </p>
													</div>
												</div>
												<p>{items?.review}</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</section>
					{/* Client Review Sec End Here */}
					{/* Footer */}
					<Footer />
					{/* Footer */}
				</div>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default Services;
